import { get } from 'lodash'

import { Colors, Services, isEmpty } from '@sigma-frontend-libs/commons'
import { EUrlShortenerSettingsPresetsAllowedScopes } from '@sigmasms/shared-types'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import entity from '@/components/entity'
import info from '@/components/info'
import selectorOwner from '@/components/selector/owner'
import expireFields from '@/components/services/url-shortener/commons/form/expireFields'
import domainId from '@/components/services/url-shortener-settings/commons/domainId'
import { urlShortenerSettingsDomainsStates } from '@/components/services/url-shortener-settings/domains/utils'
import generationParams from '@/components/services/url-shortener-settings/presets/form/generationParams'
import sticker from '@/components/sticker'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderFullUrlField(h) {
  let fullUrlError
  if (!isEmpty(this.proxy.fullUrl) && !this.isUrl) {
    fullUrlError = this.getTranslate(`${Services['url-shortener']}.hints.fullUrl`)
  }

  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.fullUrl,
        label: this.getTranslate(`${Services['url-shortener']}.labels.fullUrl`),
        hint: this.getTranslate(`${Services['url-shortener']}.hints.fullUrl`),
        error: fullUrlError,
        validateOnBlur: true,
        dense: true,
        required: true,
        autofocus: true
      },
      on: {
        input: event => {
          this.proxy.fullUrl = event
        },
        keypress: event => {
          if (event.keyCode === 13) {
            this.$emit('submit', this.proxy)
          }
        }
      }
    }
  )
}
function renderShortUrl(h) {
  if (!this.isNew) {
    return h(
      sticker,
      {
        props: {
          value: this.shortUrl,
          label: this.getTranslate(`${Services['url-shortener']}.labels.shortUrl`),
          icon: icons.link,
          color: Colors.grey,
          copy: true
        }
      }
    )
  }
}

function renderPresetOrDomain(h) {
  return h(
    sticker,
    {
      props: this.presetOrDomainStickerProps
    }
  )
}
function renderDomain(h, data) {
  const domain = get(data, '_item.domain.name', '')
  const state = get(data, '_item.domain.state', '')

  if (domain) {
    return h(
      tag,
      {
        props: {
          label: domain,
          size: sizes.small,
          color: urlShortenerSettingsDomainsStates[state].color
        }
      }
    )
  }
}
function renderPresetIdItem(h, data) {
  const title = get(data, '_item.title')

  return h(
    'div',
    {
      class: `${Services['url-shortener']}-form-presetId__item`
    },
    [
      h(
        textOverflow,
        {
          props: {
            value: title ?? this.getTranslate('commons.no.data')
          }
        }
      ),

      renderDomain.call(this, h, data)
    ]
  )
}
function renderPresetIdField(h) {
  if (this.isNew) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.presetId,
          label: this.getTranslate(`${Services['url-shortener']}.labels.presetId`),
          service: Services['url-shortener-settings/presets'],
          disabledItemCallback: this.disabledItemCallback,
          query: {
            ownerId: this.proxy.ownerId,
            scopes: EUrlShortenerSettingsPresetsAllowedScopes.domain
          },

          dense: true,
          required: true,
          clearable: false,
          autocomplete: true,
          hideSelections: true,
          setRequiredOnMounted: false,
          details: false
        },
        scopedSlots: {
          item: ({ item }) => {
            return renderPresetIdItem.call(this, h, item)
          }
        },
        on: {
          input: event => {
            this.proxy.presetId = event
          }
        }
      }
    )
  } else if (this.$_presetId) {
    return renderPresetOrDomain.call(this, h)
  }
}
function renderDomainIdField(h) {
  if (this.isNew) {
    return h(
      domainId,
      {
        props: {
          value: this.proxy.domainId,
          userId: this.proxy.ownerId,
          disabled: !this.isNew,
          required: true,
          setRequiredOnMounted: true,
          showWarnings: false
        },
        on: {
          input: event => {
            this.proxy.domainId = event
          }
        }
      }
    )
  } else if (this.$_domainId) {
    return renderPresetOrDomain.call(this, h)
  }
}
function renderGenerationParams(h) {
  if (this.isNew && this.proxy.generationParams) {
    return h(
      generationParams,
      {
        props: {
          value: this.proxy
        },
        on: {
          input: event => {
            this.proxy = event
          },
          validation: event => {
            this.generationParamsValidation = event
          }
        }
      }
    )
  }
}

function renderExpireFields(h) {
  if (this.isExpireHidden) {
    return
  }

  return h(
    expireFields,
    {
      props: {
        value: this.proxy
      },
      on: {
        input: event => {
          this.proxy = event
        },
        validation: event => {
          this.expireUrlValid = event
        }
      }
    }
  )
}

function renderTab(h, name) {
  let tabColor
  if (this.$_currentTab === name) {
    tabColor = Colors.primary
  }

  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${Services['url-shortener']}.buttons.${name}`),
        mode: buttonModes.flat,
        color: tabColor
      },
      on: {
        click: () => {
          this.$_currentTab = name
        }
      }
    }
  )
}
function renderTabs(h) {
  return [ 'byPreset', 'byDomain' ].map(name => {
    return renderTab.call(this, h, name)
  })
}
function renderTabsContent(h) {
  if (this.isNew) {
    return h(
      'div',
      {
        class: `${Services['url-shortener']}-form-row`
      },
      [ renderTabs.call(this, h) ]
    )
  }
}

function renderContentByPreset(h) {
  return renderPresetIdField.call(this, h)
}
function renderContentByParams(h) {
  return h(
    'div',
    {
      class: `${Services['url-shortener']}-form-column`
    },
    [
      renderDomainIdField.call(this, h),
      renderGenerationParams.call(this, h)
    ]
  )
}
function renderContentByTab(h) {
  switch (this.$_currentTab) {
    case 'byPreset': return renderContentByPreset.call(this, h)
    case 'byDomain': return renderContentByParams.call(this, h)
  }
}

function renderOwner(h) {
  if (this.isNew) {
    return h(
      selectorOwner,
      {
        props: {
          value: this.proxy.ownerId,
          disabled: this.loading || !this.isNew,
          dense: true,
          combobox: true
        },
        on: {
          input: event => {
            this.proxy.ownerId = event
          }
        }
      }
    )
  }
}

function renderContent(h) {
  return h(
    'div',
    {
      class: `${Services['url-shortener']}-form-content`
    },
    [
      renderFullUrlField.call(this, h),
      renderShortUrl.call(this, h),
      renderTabsContent.call(this, h),
      renderContentByTab.call(this, h),
      renderExpireFields.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}

function renderGenerationParamsEntity(h) {
  if (this.isNew || !this.$_presetId) {
    return
  }

  return h(
    entity,
    {
      props: {
        value: this.$_generationParams,
        service: Services['url-shortener'],
        pathToLabels: `${Services['url-shortener']}.labels.generationParams`,
        fields: this.$_fields
      }
    }
  )
}

function renderInfo(h) {
  if (this.isNew) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services['url-shortener']}.infos.create.${this.$_currentTab}`, { link: this.link })
        }
      }
    )
  }
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services['url-shortener']}-form`]: true,
        [`${Services['url-shortener']}-form--new`]: this.isNew
      }
    },
    [
      renderContent.call(this, h),
      renderGenerationParamsEntity.call(this, h),
      renderInfo.call(this, h)
    ]
  )
}
